import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {CancelTripModalReason} from './CancelTripModalReason/CancelTripModalReason';

export class CancelTripModalReasons extends Component {
    static propTypes = {
        category: PropTypes.string,
        onSelectReason: PropTypes.func,
        reasons: PropTypes.arrayOf(
            PropTypes.shape({
                reason: PropTypes.string,
                text: PropTypes.string,
            })
        ),
        title: PropTypes.string,
    };

    render() {
        let reasons = [];

        if (this.props.reasons) {
            this.props.reasons.forEach((reason, index) => {
                reasons.push(
                    <CancelTripModalReason
                        category={this.props.category}
                        key={index}
                        onClick={this.props.onSelectReason}
                        reason={reason}
                    />
                );
            });
        }

        return (
            <div className="CancelTrip__step">
                <div className="js-cancel-instructions">
                    <h3 className="js-cancel-category-text">
                        {this.props.title}
                    </h3>
                    <p>{this.props.description}</p>
                </div>
                {reasons}
            </div>
        );
    }
}
